/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRobotAction = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M8 6v4h2V6zm6 0v4h2V6z" />
        <path d="M4 2h16v5h2v2h-2v1.686L17.284 14H16v1.567L14.007 18H7a3.001 3.001 0 0 0-2.83 2h13.587l.005.002L16.763 22H2v-1a5 5 0 0 1 5-5h1v-2H4V9H2V7h2zm6 12v2h4v-2zM6 4v8h12V4z" />
        <path d="m17 17.5 4.5-5.5-1 4.5L24 18l-6 6 2.5-5z" />
      </g>
    </g>
  </Icon>
);
export { SvgRobotAction as RobotAction };
